import InfoIcon from "@material-ui/icons/Info";
import { IRoute } from "src/common/typings/routes";
import { ChangePasswordPage } from "./pages/ChangePassword";
import { ChangePasswordModule } from "./ChangePasswordModule";

export const ChangePasswordRoute: IRoute = {
  icon: InfoIcon,
  component: ChangePasswordModule,
  guard: true,
  path: "/change-password",
  title: "Change Password",
  subRoutes: [
    {
      icon: InfoIcon,
      component: ChangePasswordPage,
      path: "/",
      title: "Change Password",
    },
  ],
};
